"use client";
import { useState as r, useEffect as s } from "react";
const o = ({ disableSSR: e, children: t }) => {
  const [n, u] = r(!1);
  return s(() => {
    u(!0);
  }, []), e && !n ? null : t;
};
export {
  o as default
};
